import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { PersonalizedDescriptionsApiClient } from '../../api-clients';
const {
  Provider,
  ...client
} = PersonalizedDescriptionsApiClient;
export const PersonalizedDescriptionsExtension = createModuleExtension({
  extensionName: 'personalizedDescriptionsExtension',
  Provider,
  SDK: {
    personalizedDescriptionsApiClient: client
  }
});
//# sourceMappingURL=personalized-descriptions.extension.js.map